import { useState, useEffect, useRef } from 'react';

const useSearchFocusOnClose = () => {
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const focusElementRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && isSearchModalOpen) {
                setIsSearchModalOpen(false);
                focusElementRef.current?.focus();
            }
        };

        if (isSearchModalOpen) {
            document.addEventListener('keydown', handleKeydown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [isSearchModalOpen]);

    return {
        isSearchModalOpen,
        setIsSearchModalOpen,
        focusElementRef,
    };
};

export default useSearchFocusOnClose;
